import { CoreReducer } from "../redux-state/core/core-reducer";

export default {
  core: CoreReducer,
};
